export default (date: Date | undefined): string => {
  if (date !== undefined) {
    return new Intl.DateTimeFormat().format(new Date(date));
  }
  return '';
};
